import type {
  AssetOcppConfigurationKeyRow,
  AssetOcppConfigurationSnapshot,
} from './types';

export function filterConfigurationRows(
  rows: AssetOcppConfigurationKeyRow[],
  search: string,
): AssetOcppConfigurationKeyRow[] {
  const normalized = search.trim().toLowerCase();
  if (!normalized) {
    return rows;
  }
  return rows.filter((row) => {
    const key = row.key.toLowerCase();
    const value = (row.value ?? '').toLowerCase();
    return key.includes(normalized) || value.includes(normalized);
  });
}

export function displayConfigurationValue(
  value: string | null,
  emptyLabel: string,
): string {
  if (value == null || value === '') {
    return emptyLabel;
  }
  return value;
}

export function displayReadonly(
  value: boolean | null,
  labels: { yes: string; no: string; empty: string },
): string {
  if (value === true) {
    return labels.yes;
  }
  if (value === false) {
    return labels.no;
  }
  return labels.empty;
}

export function configurationRowsFromSnapshot(
  snapshot: AssetOcppConfigurationSnapshot | null,
): AssetOcppConfigurationKeyRow[] {
  return snapshot?.configurationKey ?? [];
}
